import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from '../app.service';
import { Configs } from '../app.config';
import { MatDialog, MAT_DIALOG_DATA, MatTabGroup, MatTab } from '@angular/material';
import { DialogDataExampleDialog } from '../popup.component';
import { MzModalComponent } from 'ngx-materialize';
import { element } from '@angular/core/src/render3/instructions';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatAutocompleteSelectedEvent, MatChipInputEvent} from '@angular/material';





@Component({
  selector: 'app-special-incentives',
  templateUrl: './special-incentives.component.html',
  styleUrls: ['./special-incentives.component.less']
})
export class SpecialIncentivesComponent implements OnInit {


  @ViewChild('AddSpecialIncentive') AddSpecialIncentive: MzModalComponent
  @ViewChild('ChipPSNoInput') ChipPSNoInput: ElementRef;
  autocomplete: { data: { [key: string]: string|null } };
  autocompletetable: { data: { [key: string]: string } };
  Psno: any;
  SpecialIncentiveApprovalID: any;
  UserPsno: any;
  userInfo: any;
  dropdownSettings: any = {};
  periodid: any;
  periodYear: any;
  periodValues: any;
  dropdownIncentives: any = [];
  SelectedIncentive: any = [];
  AllowedIncentivesForPeriod: any = [];
  SelectedIncentiveIdArray: any = [];
  SearchPsnoModal: any;
  ModalDate: any;
  UploadOptionTypes: any = [];
  si_typeOptionSelected: any;
  IncentivesByPeriodMaster: any = [];
  UserMasterForModal: any = [];
  CurrencyTypes: any = [];
  currency_typeOptionSelected: any;
  Amount: any;
  SpecialIncentiveDataForUser: any = [];
  SIModalSubmitValidation: string = '';
  dataSource: any;
  dataSource_Open_WithMe: any;
  dataSource_Closed: any;
  dataSource_Open_InProcess: any;
  LoggedInUserRole: any;
  LoggedInUserRoleText: any;
  IsDownload: boolean = false;
  isCBOAndManager: boolean = false;
  displayedColumns: string[] = ['select', 'name', 'manager', 'sbu', 'role'];
  GridId: string = '1';
  selectAllPsno: boolean = false;
  selectAll: boolean = true;
  SelectedRecords: any = [];
  ShowApprRejBtns: boolean = false;
  ShowReleaseBtns: boolean = false;
  ShowSubmitApprovalBtn: boolean = false;
  ShowFilters: boolean = false;
  tblStatusOrginal: any;
  filters: any;
  SearchTextTable: any;
  visible: boolean = true;
  selectable: boolean = true;
  removable: boolean = true;
  addOnBlur: boolean = false;
  separatorKeysCodes = [ENTER, COMMA];
  ChipPSNoCtrl = new FormControl();
  filteredChipPSNos: Observable<any[]>;
  ChipPSNos:any = [];
  allChipPSNos:any = [];
  SpecialIncentiveName: any;

  accountName: any;
  dealValue: any;
  netNew: any;
  soldEbit: any;
  newServiceLine: any;
  revenueContribution: any;
  revenue: any;
  ebitPercentage: any;
  first12MonthRevenue: any;
  rateChangePercentage: any;
  revenueImpact: any;
  L_SpecialIncentiveStatus: any;
  L_SpecialIncentivePendingWith: any;
  L_AppType: any;
  L_PeriodId: any;

  isReadOnly: boolean = false;









  constructor(private appService: AppService, private configs: Configs, private router: Router, private route: ActivatedRoute, public dialog: MatDialog) {
    this.appService.SetLoadingShow(false);
    this.UserPsno = '';
    this.SpecialIncentiveApprovalID = 0;
    this.periodid = 0;
    this.periodYear = '0';
    this.periodValues = [];
    this.SelectedIncentive = [];
    this.ChipPSNos = [];
    this.SearchPsnoModal = '';
    this.si_typeOptionSelected = 0;
    this.currency_typeOptionSelected = '';
    this.Amount = 0
    this.autocomplete = {
      data: {
        "1":null
      }
    };
    this.dataSource = [];
    this.dataSource_Open_WithMe = [];
    this.dataSource_Open_InProcess = [];
    this.dataSource_Closed = [];
    this.LoggedInUserRole = 0;
    this.LoggedInUserRoleText = '';
    this.ShowFilters = false;
    this.tblStatusOrginal = [];
    this.filters = {
      'dtStatusType': [],
      'dtSBU': [],
      'dtRole': [],
      'dtStatusTiles': [],
      'FiltersDataArr': [],
      'dtFunction': []
    };
    this.SearchTextTable = '';
    this.SpecialIncentiveName = '';

    this.accountName = '';
    this.dealValue = 0;
    this.netNew = 0;
    this.soldEbit =  0;
    this.newServiceLine = '';
    this.revenueContribution = 0;
    this.revenue = 0;
    this.ebitPercentage = 0;
    this.first12MonthRevenue = 0;
    this.rateChangePercentage = 0;
    this.revenueImpact = 0;
    this.L_SpecialIncentiveStatus = '';
    this.L_SpecialIncentivePendingWith = '';
    this.L_AppType = 1;
    this.L_PeriodId = 1;

    this.filteredChipPSNos = this.ChipPSNoCtrl.valueChanges.pipe(
      startWith(''),
      map((ChipPSNo: string | null) => ChipPSNo ? this.filterChipPSNo(ChipPSNo) : this.allChipPSNos.slice()));
      console.log("fcpn");
      this.filteredChipPSNos.subscribe(value => {
        console.log(value);
      });
   }

  ngOnInit() {
    this.userInfo = this.appService.GetLoginUserInfo();
    if (this.userInfo != null) {
      var checkAccess = this.appService.CheckAccessForRoute(this.router.url, this.userInfo.UserAccessOptions);
      if (checkAccess) {
        this.UserPsno = this.userInfo.PS_No;
        this.LoggedInUserRole = this.userInfo.SPMRoles[0].RoleID;
        this.dropdownSettings = {
          singleSelection: false,
          text: "Select",
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          enableSearchFilter: false,
          badgeShowLimit: 1,
          classes: ""
        };
        this.isCBOAndManager = false;
        var TargetScreenRoles = this.appService.GetUserRoleForTargetApproval(this.userInfo.SPMRoles);
              
        
              if (TargetScreenRoles.Employee > 0) {
                this.LoggedInUserRoleText = 'SalesExecutive';
                this.IsDownload = false;
                this.LoggedInUserRole = TargetScreenRoles.SalesExecutiveId;
              }
              else if (TargetScreenRoles.CSRoleId > 0) {
                this.LoggedInUserRoleText = 'SE';
                this.IsDownload = true;
                this.LoggedInUserRole = TargetScreenRoles.CSRoleId;
              }

              else if (TargetScreenRoles.CNBRoleId > 0) {
                this.LoggedInUserRoleText = 'CNB';
                this.IsDownload = true;
                this.LoggedInUserRole = TargetScreenRoles.CNBRoleId;
              }
              else if (TargetScreenRoles.SELARoleId > 0) {
                this.LoggedInUserRoleText = 'SELA';
                this.IsDownload = true;
                this.LoggedInUserRole = TargetScreenRoles.SELARoleId;
              }
              else if (TargetScreenRoles.HRRoleId > 0) {
                this.LoggedInUserRoleText = 'HR';
                this.IsDownload = true;
                this.LoggedInUserRole = TargetScreenRoles.HRRoleId;
              }
              // Some Manager also have HR Role - Access Override  
              if (TargetScreenRoles.MGRRoleId > 0) {
                this.LoggedInUserRoleText = 'Manager';
                this.IsDownload = false;
                this.LoggedInUserRole = TargetScreenRoles.MGRRoleId;
              }
              // if sales excellence then only use this role
              if (TargetScreenRoles.CSRoleId > 0) {
                this.LoggedInUserRoleText = 'SE';
                this.IsDownload = true;
                this.LoggedInUserRole = TargetScreenRoles.CSRoleId;
              }

              // CBO Role Priority  
              if (TargetScreenRoles.CBORoleId > 0) {
                this.LoggedInUserRoleText = 'CBO';
                if (TargetScreenRoles.MGRRoleId > 0) {
                  this.isCBOAndManager = true;
                  this.IsDownload = true;
                }
                this.LoggedInUserRole = TargetScreenRoles.CBORoleId;
              }
              else if (TargetScreenRoles.FunctionHeadId > 0) {
                this.LoggedInUserRoleText = 'FunctionHead';
                this.IsDownload = true;
                this.LoggedInUserRole = TargetScreenRoles.FunctionHeadId;
              }
              console.log("Role - " + this.LoggedInUserRoleText);
        var UserData = {
          "PS_No": this.userInfo.PS_No,
          "AppType": this.userInfo.AppType
        }
        this.appService.SetLoadingShow(true);
        this.appService.GetDataFromAPI(this.configs.GetDataForSpecialIncentivesURL(), UserData)
          .then(response => {
            this.appService.SetLoadingShow(false);
            if (response.ResponseCode == this.configs.RetCodeFailure()) {
              this.dialog.open(DialogDataExampleDialog, {
                data: response.ResponseData
              });
            }
            else {
              this.periodValues = response.ResponseData.dtYearsForSpecialIncentives;
              this.periodYear = response.ResponseData.dtYearsForSpecialIncentives[0].TargetUploadYearText;
              this.periodid= response.ResponseData.dtYearsForSpecialIncentives[0].periodid;
              this.IncentivesByPeriodMaster = response.ResponseData.dtApplicableIncentivesForYear;
              this.UserMasterForModal = response.ResponseData.dtUserMaster
              this.CurrencyTypes = response.ResponseData.dtCurrencyMaster
              this.UserMasterForModal.forEach(item => {
                this.autocomplete.data[`${item.psno} - ${item.name}`] = null;
            });
              console.log(this.autocomplete);
              console.log("um " + JSON.stringify(this.UserMasterForModal));
              // this.allChipPSNos = this.UserMasterForModal.map(user => user.psno);
              this.allChipPSNos = this.UserMasterForModal.map(user => `${user.psno} - ${user.name}`);
              console.log("cps " + JSON.stringify(this.ChipPSNos));
              console.log(this.allChipPSNos);
              this.onChangeOFPeriod(this.periodid);             
            }
          });
      }
      else {
        this.router.navigate(['no-access']);
      }
    }
    else {
      window.location.href = "../Index.html";
    }
  }

  Reload() {
    this.filters.FiltersDataArr = [];
    this.dataSource_Open_WithMe = [];
    this.dataSource_Open_InProcess = [];
    this.dataSource_Closed = [];
    this.dataSource = [];

    var data = {
      'periodid': this.periodid,
      'PSNo': this.userInfo.PS_No,
      'Role': this.LoggedInUserRoleText,
      'AppType': this.userInfo.AppType,
      'SelectedSpecialIncentive': this.SelectedIncentiveIdArray.join(),
    };
     this.appService.SetLoadingShow(true);
    this.appService.GetDataFromAPI(this.configs.GetUploadedSpecialIncentivesURL(), data)
      .then(response => {
       // this.appService.SetLoadingShow(false);
        if (response.ResponseCode == this.configs.RetCodeFailure()) {
          this.dialog.open(DialogDataExampleDialog, {
            data: response.ResponseData
          });
        }
        else {        
          // this.filters.dtStatusType = response.ResponseData.dtStatusType;
          // this.dropdownListStatus = [];
          // for (var o in this.filters.dtStatusType) {
          //   this.dropdownListStatus.push({ "id": parseInt(o) + 1, "itemName": this.filters.dtStatusType[o].Type });
          // }
          // this.selectedStatus = JSON.parse(JSON.stringify(this.dropdownListStatus));
          // this.SalesMetricColumns = response.ResponseData.metricsMasters;
          // this.filters.dtSBU = response.ResponseData.dtSBU;
          // this.dropdownListSBU = [];
          // for (var o in this.filters.dtSBU) {
          //   this.dropdownListSBU.push({ "id": parseInt(o) + 1, "itemName": this.filters.dtSBU[o].DeputedBU, "Functionid": this.filters.dtSBU[o].FunctionId });
          // }
          // this.selectedSBU = JSON.parse(JSON.stringify(this.dropdownListSBU));
          // var SBU = [];
          // for (var j in this.selectedSBU) {
          //   if (SBU.indexOf(this.selectedSBU[j].itemName) == -1) {
          //     SBU.push(this.selectedSBU[j].itemName)
          //   }
          // }
          // for (var o in SBU) {
          //   this.SBUDistinct.push({ "id": parseInt(o) + 1, "itemName": SBU[o]})
          // }
          // this.SBUDistinctModel = JSON.parse(JSON.stringify(this.SBUDistinct));
          // this.filters.dtFunction = response.ResponseData.dtFunction;
          // this.dropdownListFunction = [];
          // for (var o in this.filters.dtFunction) {
          //   this.dropdownListFunction.push({ "id": this.filters.dtFunction[o].FunctionId, "itemName": this.filters.dtFunction[o].FunctionName });
          // }
          // this.selectedFunction = JSON.parse(JSON.stringify(this.dropdownListFunction));

          // this.filters.dtRole = response.ResponseData.dtRole;
          // this.dropdownListRole = [];
          // for (var o in this.filters.dtRole) {
          //   this.dropdownListRole.push({ "id": this.filters.dtRole[o].RoleID, "itemName": this.filters.dtRole[o].RoleName, "itemValue": this.filters.dtRole[o].RoleID });
          // }
          // this.roleSelected = JSON.parse(JSON.stringify(this.dropdownListRole));

          // this.filters.dtStatusTiles = response.ResponseData.dtTiles;
   
          if (response.ResponseData.SpecialIncentivesList.length > 0) {


            this.appService.SetBulkUploadList(response.ResponseData.SpecialIncentivesList);
            var data = this.appService.GetBulkUploadList();
            for (var o in data) {
              //if (parseInt(data[o].StatusID) > 0) {
                if (this.LoggedInUserRoleText == 'Manager') {


                  if (parseInt(data[o].StatusID) > 2) {
                    this.dataSource.push(data[o]);
                  }
                }
                else {
                  this.dataSource.push(data[o]);
                }
             // }
              }
              // if (this.dataSource.length > 0) {
              //     if (this.dataSource[0].IsH1PeriodApplicable == '1') {
              //         this.isH1Applicable = true;
              //     }
              //     else {
              //         this.isH1Applicable = false;
              //     }
              //     this.AppType = this.dataSource[0].AppType;
              // }
            
            this.tblStatusOrginal = JSON.parse(JSON.stringify(this.dataSource));
            // this.tblStatusData = JSON.parse(JSON.stringify(this.dataSource));
            this.filters.FiltersDataArr = JSON.parse(JSON.stringify(this.dataSource));

            // for (var o in this.filters.dtStatusTiles) {
            //   if (this.filters.dtStatusTiles[o].Status == 'Total Eligible') {
            //     this.TotalEligibleNumber = this.RefreshCount(this.filters.dtStatusTiles[o].Status);
            //   }
            //   if (this.filters.dtStatusTiles[o].Status == 'Targets Not Uploaded') {
            //     this.TargetsNotUploadedNumber = this.RefreshCount(this.filters.dtStatusTiles[o].Status);
            //   }
            //   if (this.filters.dtStatusTiles[o].Status == 'Total Uploaded') {
            //     this.TotalUploadedNumber = this.RefreshCount('Total Eligible') - this.RefreshCount('Targets Not Uploaded');
            //   }
            // }
          
            // this.InitializeNumbers();
            this.ShowFilters = true;
            if (this.dataSource.length == 0) {
              this.dialog.open(DialogDataExampleDialog, {
                data: "No Data available"
              });
              //return;
            }           
            // this.DownloadFilePath = this.DownloadFilePathBase;
           
            for (var x in this.dataSource) {

              if (this.LoggedInUserRoleText == 'CBO') {
                if (this.dataSource[x].CBOPSNo == this.userInfo.PS_No && this.dataSource[x].PendingWith == 'CBO') {
                  // this.LoggedInUserRoleText = 'Manager'; // Overriding for manager approvals
                  this.isCBOAndManager = true;
                }
              }



              // for (var o in this.dataSource[x].matricsDataList) {
              //   if (this.dataSource[x].matricsDataList[o].Target == null || this.dataSource[x].matricsDataList[o].Target == undefined) {
              //     this.dataSource[x].matricsDataList[o].Target = 'NA';
              //   }
              //   if (this.dataSource[x].matricsDataList[o].OldTarget == null || this.dataSource[x].matricsDataList[o].OldTarget == undefined) {
              //     this.dataSource[x].matricsDataList[o].OldTarget = 'NA';
              //   }
              //   if (this.dataSource[x].matricsDataList[o].Actual == null || this.dataSource[x].matricsDataList[o].Actual == undefined) {
              //     this.dataSource[x].matricsDataList[o].Actual = 'NA';
              //   }


              // }
            }


            for (var o in this.dataSource) {
              console.log("this.isCBOAndManager - " + this.isCBOAndManager);
              console.log("this.LoggedInUserRoleText - " + this.LoggedInUserRoleText);
              console.log("this.dataSource[o].PendingWith - " + this.dataSource[o].PendingWith);
              console.log("this.dataSource[o].CBOPSNO - " + this.dataSource[o].CBOPSNo);
              console.log("this.userInfo.PS_No - " + this.userInfo.PS_No);

              this.dataSource[o].select = false;
              if (this.dataSource[o].StatusDesc == 'Special Incentive Letter Released' || this.dataSource[o].StatusDesc == 'Special Incentive Not Uploaded') {
                this.dataSource_Closed.push(this.dataSource[o])
              }
              else {
               if (this.dataSource[o].PendingWith != this.LoggedInUserRoleText) {
                 if (this.isCBOAndManager && this.dataSource[o].StatusID == "8" || (this.dataSource[o].PendingWith == 'HR' && ('FunctionHead' == this.LoggedInUserRoleText ||'SELA' == this.LoggedInUserRoleText)) || (this.isCBOAndManager && this.dataSource[o].StatusID == "3") || (this.dataSource[o].PendingWith == 'CBO' && this.dataSource[o].CBOPSNo == this.userInfo.PS_No)) {
                    this.dataSource_Open_WithMe.push(this.dataSource[o]);
                  }
                  else {
                    this.dataSource_Open_InProcess.push(this.dataSource[o]);
                  }

                 // this.dataSource_Open_InProcess.push(this.dataSource[o]);
                }
                else {
                  if (this.LoggedInUserRoleText == 'CBO') {
                    if (this.dataSource[o].CBOPSNo == this.userInfo.PS_No) {
                      this.dataSource_Open_WithMe.push(this.dataSource[o]);
                    }
                    else {
                      this.dataSource_Open_InProcess.push(this.dataSource[o]);
                    }
                  }
                  else {
                    this.dataSource_Open_WithMe.push(this.dataSource[o]);
                  }

                }

              }


            }
            this.ShowApprRejBtns = false;
            this.ShowReleaseBtns = false;
            this.ShowSubmitApprovalBtn = false;
            for (var o in this.dataSource_Open_WithMe) {
              if (!this.ShowSubmitApprovalBtn && this.dataSource_Open_WithMe[o].StatusID == "8" && (this.LoggedInUserRoleText == 'HR' || this.LoggedInUserRoleText == 'CBO' || this.LoggedInUserRoleText == 'SELA' || this.LoggedInUserRoleText=='FunctionHead')) {
                this.ShowSubmitApprovalBtn = true;
              }
              if (!this.ShowApprRejBtns && (this.dataSource_Open_WithMe[o].StatusID == "1" || this.dataSource_Open_WithMe[o].StatusID == "9") && (this.LoggedInUserRoleText == 'SE' )) {
                this.ShowApprRejBtns = true;

              }
              if (!this.ShowApprRejBtns && (this.dataSource_Open_WithMe[o].StatusID == "2") && this.LoggedInUserRoleText == 'CNB') {
                this.ShowApprRejBtns = true;

              }
              if (!this.ShowReleaseBtns && (this.dataSource_Open_WithMe[o].StatusID == "3") && (this.LoggedInUserRoleText == 'CBO' || this.userInfo.PS_No == '10637701')) {
                this.ShowReleaseBtns = true;

              }
            }
            // for (var o in this.dataSource_Closed) {

            //   if (!this.ShowEditBtn && this.dataSource_Closed[o].StatusID != "14" && (this.LoggedInUserRoleText == 'HR' || this.LoggedInUserRoleText == 'SE' || this.LoggedInUserRoleText == 'CBO' || this.LoggedInUserRoleText == 'SELA' || this.LoggedInUserRoleText == 'FunctionHead' )) {
            //     this.ShowEditBtn = true;
            //   }

            // }
            this.selectAll = false;

            this.displayedColumns = ['select', 'PSNo', 'name', 'manager', 'sbu', 'role'];
          }
          else {
            this.dialog.open(DialogDataExampleDialog, {
              data: "No Data available"
            });
          }
          // if (response.ResponseData.allowedPeriodUploads.length > 0) {
          //   this.AllowedPeriodUpload = response.ResponseData.allowedPeriodUploads;
          // }       
        }
        if (response.ResponseCode == "SUCCESS") {
          this.appService.SetLoadingShow(false);
        }
        else {
          if (response.ResponseCode == "FAILURE") {
            this.appService.SetLoadingShow(false);
          }
        }
      //  this.appService.SetLoadingShow(false);
      });   
  }

  onChangeOFPeriod(id) {
    if (id != null) {
      this.appService.SetLoadingShow(true);
      this.periodid = id;
      this.dropdownIncentives = [];
      this.dataSource = [];
      this.dataSource_Open_WithMe = [];
      this.dataSource_Open_InProcess = [];
      this.dataSource_Closed = [];
      this.ShowApprRejBtns = false;
      this.ShowReleaseBtns = false;
      this.ShowSubmitApprovalBtn = false;
      this.filters.FiltersDataArr = [];
      this.FilterIncentives(id);
      this.appService.SetLoadingShow(false);
    }
    else {
      this.periodid = 0;
    }
  }

  FilterIncentives(periodid) {
    this.SelectedIncentive = [];
    this.AllowedIncentivesForPeriod = [];
    this.dropdownIncentives = [];
    if (this.userInfo.AppType == 1) {
      for (var o in this.IncentivesByPeriodMaster) {
        if (this.IncentivesByPeriodMaster[o].PeriodId == periodid) {
          this.AllowedIncentivesForPeriod.push(this.IncentivesByPeriodMaster[o]);
        }
      }
    }
    console.log(this.AllowedIncentivesForPeriod);
    for (var o in this.AllowedIncentivesForPeriod) {
      this.dropdownIncentives.push({ "id": this.AllowedIncentivesForPeriod[o].SpecialIncentiveId, "itemName": this.AllowedIncentivesForPeriod[o].SpecialIncentiveName });
    }
    console.log(this.dropdownIncentives);

    // var IsNavBwtweenTargetDashBoardAndMyTargets = this.appService.GetIsNavBwtweenTargetDashBoardAndMyTargets();
    // if (IsNavBwtweenTargetDashBoardAndMyTargets) {
    //   this.appService.SetIsNavBwtweenTargetDashBoardAndMyTargets(false);
    //   var dataForLoading = this.appService.GetDashBoardData();
    //   if (dataForLoading != null) {
    //     this.Selectedrole = dataForLoading['Selectedrole'];
    //     this.ChangeIncentive(this.Selectedrole);
    //   }
    // }
    // else {
    //   this.appService.SetLoadingShow(false);
    // }
    
  }

  ChangeIncentive(Incentive) {

    this.SelectedIncentiveIdArray = [];
    for (var o in Incentive) {
      this.SelectedIncentiveIdArray.push(Incentive[o].id);
    }
    // this.ShowMetricsFlag = false;
    // if (this.SelectedIncentiveIdArray.length == 1) {
    //   this.ShowMetricsFlag = true;
    // }
    this.Reload();
    
  }

  SearchPsno(value): any {
    // var data = JSON.parse(JSON.stringify(this.UserMasterForModal));
    // if (value != '' && value != undefined) {
    //   if (value.length > 2) {
    //     const filterValue = value.toLowerCase();
    //     this.SearchTextModal = value;
    //     for (var o in data) {
    //       if (data[o].name == null)
    //         data[o].name = "";
    //       if (data[o].manager == null)
    //         data[o].manager = "";
    //     }
    //     data = data.filter(option => option.name.toLowerCase().includes(filterValue) || option.manager.toLowerCase().includes(filterValue) || option.psNo.toString().toLowerCase().includes(filterValue));
    //   }
    // }
  }

  SearchModalPsno(event): any {
    this.SearchPsnoModal = event.target.value;
  }

  // SearchModalPsno(psno): any {
  //   var Psno = psno.option.value;
  //   for (var o in this.UserMasterForModal) {
  //     if (this.UserMasterForModal[o].psno == psno) {
  //       this.SearchPsnoModal = this.UserMasterForModal[o].psno;
  //       break;
  //     }
  //   }
  // }

  SearchForTable(value): any {
    this.filters.FiltersDataArr = [];
    this.dataSource_Closed = [];
    this.dataSource_Open_WithMe = [];
    this.dataSource_Open_InProcess = [];
    var data = JSON.parse(JSON.stringify(this.tblStatusOrginal));
    console.log(data);
    if (value != '' && value != undefined) {
      if (value.length > 2) {
        const filterValue = value.toLowerCase();
        this.SearchTextTable = value;
        for (var o in data) {
          if (data[o].name == null)
            data[o].name = "";
          if (data[o].ManagerName == null)
            data[o].ManagerName = "";
          if (data[o].CBOName == null)
            data[o].CBOName = "";
        }
        data = data.filter(option => option.name.toLowerCase().includes(filterValue) || option.PSNOsString.toLowerCase().includes(filterValue) || option.CBOName.toLowerCase().includes(filterValue) || option.CBOPSNo.toString().toLowerCase().includes(filterValue));
      }
    }
    for (var o in data) {

      if (data[o].StatusDesc == 'Special Incentive Letter Released' || data[o].StatusDesc == 'Special Incentive Not Uploaded') {
        this.dataSource_Closed.push(data[o]);
        this.filters.FiltersDataArr.push(data[o]);
      }
      else {
        if (data[o].PendingWith != this.LoggedInUserRoleText) {
          if (this.isCBOAndManager && data[o].StatusID == "8" || (data[o].PendingWith == 'HR' && ('FunctionHead' == this.LoggedInUserRoleText ||'SELA' == this.LoggedInUserRoleText)) || (this.isCBOAndManager && data[o].StatusID == "3") || (data[o].PendingWith == 'CBO' && data[o].CBOPSNo == this.userInfo.PS_No)) {
            this.dataSource_Open_WithMe.push(data[o]);
            this.filters.FiltersDataArr.push(data[o]);
          }
          else {
            this.dataSource_Open_InProcess.push(data[o]);
            this.filters.FiltersDataArr.push(data[o]);
          }
        }
        else {
          if (this.LoggedInUserRoleText == 'CBO') {
            if (data[o].CBOPSNO == this.userInfo.PS_No) {
              this.dataSource_Open_WithMe.push(data[o]);
              this.filters.FiltersDataArr.push(data[o]);
            }
            else {
              this.dataSource_Open_InProcess.push(data[o]);
              this.filters.FiltersDataArr.push(data[o]);
            }
          }
          else {
            this.dataSource_Open_WithMe.push(data[o]);
            this.filters.FiltersDataArr.push(data[o]);
          }
        }
      }
    }
    // this.InitializeNumbers();

  }

  AddSpecialIncentiveModal(SpecialIncentiveApprovalId: string, periodid: string, readonly: boolean) {
    this.isReadOnly = readonly;
    console.log("read");
    console.log(readonly);
    console.log(this.isReadOnly);
  if(SpecialIncentiveApprovalId == '0' && periodid == '0') {
    this.SearchPsnoModal = '';
    this.SpecialIncentiveApprovalID = -1;
    this.ChipPSNos = [];
    this.si_typeOptionSelected = 0;
    this.currency_typeOptionSelected = 'USD';
    this.Amount = 0;
    this.ModalDate = undefined;

    this.accountName = '';
    this.dealValue = 0;
    this.netNew = 0;
    this.soldEbit =  0;
    this.newServiceLine = '';
    this.revenueContribution = 0;
    this.revenue = 0;
    this.ebitPercentage = 0;
    this.first12MonthRevenue = 0;
    this.rateChangePercentage = 0;
    this.revenueImpact = 0;

    this.AddSpecialIncentive.openModal();
  }

  else {
  this.SpecialIncentiveApprovalID = SpecialIncentiveApprovalId;
  var data = {
  'SpecialIncentiveApprovalId': SpecialIncentiveApprovalId,
  'PeriodId': periodid,
  'AppType': this.userInfo.AppType
}

this.appService.SetLoadingShow(true);
var url = this.configs.GetSpecialIncentiveForUserURL();

this.appService.GetDataFromAPI(url, data)
  .then(response => {
    this.appService.SetLoadingShow(false);
    if (response.ResponseCode == this.configs.RetCodeFailure()) {
      this.dialog.open(DialogDataExampleDialog, {
        data: response.ResponseData
      });
    }
    else {
      this.SpecialIncentiveDataForUser = [];
      this.SpecialIncentiveDataForUser = response.ResponseData.SpecialIncentivesList;

      console.log(this.si_typeOptionSelected + " cr1 " + this.currency_typeOptionSelected);
      console.log(this.SpecialIncentiveDataForUser);


      if (this.SpecialIncentiveDataForUser.length > 0) {
          this.SearchPsnoModal = this.SpecialIncentiveDataForUser[0].CBOPSNo;
          // this.ChipPSNos = this.SpecialIncentiveDataForUser[0].PSNOs;
          this.ChipPSNos = [];
          for (let i = 0; i < this.SpecialIncentiveDataForUser[0].PSNo.length; i++) {
            this.ChipPSNos.push(this.SpecialIncentiveDataForUser[0].PSNo[i].PSNO);
        }
          this.ModalDate = this.SpecialIncentiveDataForUser[0].Date;
          for(var i=0; i< this.AllowedIncentivesForPeriod.length; i++) {
            if(this.AllowedIncentivesForPeriod[i].SpecialIncentiveId == this.SpecialIncentiveDataForUser[0].SpecialIncentiveType) {
              this.si_typeOptionSelected = this.AllowedIncentivesForPeriod[i].SpecialIncentiveId;
              console.log(this.AllowedIncentivesForPeriod[i].SpecialIncentiveId + " si2 " + this.SpecialIncentiveDataForUser[0].SpecialIncentiveType);
              break;
            }
            console.log(this.AllowedIncentivesForPeriod[i].SpecialIncentiveId + " si1 " + this.SpecialIncentiveDataForUser[0].SpecialIncentiveType);
          }
          for(var i=0; i< this.CurrencyTypes.length; i++) {
            if(this.CurrencyTypes[i].currency == this.SpecialIncentiveDataForUser[0].Currency) {
              this.currency_typeOptionSelected = this.SpecialIncentiveDataForUser[0].Currency;
              console.log(this.CurrencyTypes[i].currency + " cur2 " + this.SpecialIncentiveDataForUser[0].Currency);
              break;
            }
            console.log(this.CurrencyTypes[i].currency + " cur1 " + this.SpecialIncentiveDataForUser[0].Currency);

          }
          this.Amount = this.SpecialIncentiveDataForUser[0].TotalValue;
          this.SpecialIncentiveName = this.SpecialIncentiveDataForUser[0].SpecialIncentiveName;

          this.accountName = this.SpecialIncentiveDataForUser[0].AccountName;
          this.dealValue = this.SpecialIncentiveDataForUser[0].DealValue;
          this.netNew = this.SpecialIncentiveDataForUser[0].NetNew;
          this.soldEbit = this.SpecialIncentiveDataForUser[0].SoldEBIT;
          this.newServiceLine = this.SpecialIncentiveDataForUser[0].NewServiceLine;
          this.revenueContribution = this.SpecialIncentiveDataForUser[0].RevenueContribution;
          this.revenue = this.SpecialIncentiveDataForUser[0].Revenue;
          this.ebitPercentage = this.SpecialIncentiveDataForUser[0].EBITPercentage;
          this.first12MonthRevenue = this.SpecialIncentiveDataForUser[0].First12MonthRevenue;
          this.rateChangePercentage = this.SpecialIncentiveDataForUser[0].RateChangePercentage;
          this.revenueImpact = this.SpecialIncentiveDataForUser[0].RevenueImpact;
          this.L_SpecialIncentiveStatus = this.SpecialIncentiveDataForUser[0].StatusDesc;
          this.L_SpecialIncentivePendingWith = this.SpecialIncentiveDataForUser[0].PendingWith;
          this.L_AppType = this.SpecialIncentiveDataForUser[0].Apptype;
          this.L_PeriodId = this.SpecialIncentiveDataForUser[0].PeriodId;



          console.log(this.si_typeOptionSelected + " cr2 " + this.currency_typeOptionSelected);
          console.log(this.CurrencyTypes);
          console.log(this.SearchPsnoModal);
          console.log("data init");
          console.log(this.SearchPsnoModal);
          console.log(this.SpecialIncentiveApprovalID);
          console.log(this.ChipPSNos);
          console.log(this.si_typeOptionSelected);
          console.log(this.currency_typeOptionSelected);
          console.log(this.Amount);
          console.log(this.ModalDate);
          console.log(this.accountName);
          console.log(this.dealValue);
          console.log(this.netNew);
          console.log(this.soldEbit);
          console.log(this.newServiceLine);
          console.log(this.revenueContribution);
          console.log(this.revenue);
          console.log(this.ebitPercentage);
          console.log(this.first12MonthRevenue);
          console.log(this.rateChangePercentage);
          console.log(this.revenueImpact);
          this.AddSpecialIncentive.openModal();
        }
        else {
          this.dialog.open(DialogDataExampleDialog, {
            data: "No data available"
          });
      }
    }
    


    }
    ,
    error => {

    });
  }
}

  SaveSpecialIncentive() {

    console.log("ssi "  + this.ChipPSNos);

    this.SIModalSubmitValidation = '';
      if(this.Amount <= 0) {
        this.SIModalSubmitValidation = "Amount should be greater than 0";
      }
      if(this.si_typeOptionSelected == 0) {
        this.SIModalSubmitValidation = "Select Special Incentive Type";
      }
      if(this.si_typeOptionSelected == 1) {
        if(this.accountName == '' || this.accountName == null) {
          this.SIModalSubmitValidation = "Enter Account Name";
        }
        if(this.dealValue == 0) {
          this.SIModalSubmitValidation = "Enter Deal Value";
        }
        if(this.netNew == 0) {
          this.SIModalSubmitValidation = "Enter Net New";
        }
        if(this.soldEbit == 0) {
          this.SIModalSubmitValidation = "Enter Sold EBIT";
        }
      }
      if(this.si_typeOptionSelected == 2) {
        if(this.accountName == '' || this.accountName == null) {
          this.SIModalSubmitValidation = "Enter Account Name";
        }
        if(this.newServiceLine == '' || this.newServiceLine == null) {
          this.SIModalSubmitValidation = "Enter New Service Line";
        }
        if(this.revenueContribution == 0) {
          this.SIModalSubmitValidation = "Enter Revenue Contribution";
        }
      }
      if(this.si_typeOptionSelected == 3) {
        if(this.accountName == '' || this.accountName == null) {
          this.SIModalSubmitValidation = "Enter Account Name";
        }
        if(this.revenue == 0) {
          this.SIModalSubmitValidation = "Enter Revenue";
        }
      }
      if(this.si_typeOptionSelected == 4) {
        if(this.accountName == '' || this.accountName == null) {
          this.SIModalSubmitValidation = "Enter Account Name";
        }
        if(this.ebitPercentage == 0) {
          this.SIModalSubmitValidation = "Enter EBIT Percentage";
        }
        if(this.first12MonthRevenue == 0) {
          this.SIModalSubmitValidation = "Enter First 12 Months Revenue";
        }
      }
      if(this.si_typeOptionSelected == 5) {
        if(this.accountName == '' || this.accountName == null) {
          this.SIModalSubmitValidation = "Enter Account Name";
        }
        if(this.rateChangePercentage == 0) {
          this.SIModalSubmitValidation = "Enter Rate Change applicate to what % of Revenue";
        }
        if(this.revenueImpact == 0) {
          this.SIModalSubmitValidation = "Enter Revenue Impact due to Rate Change";
        }
      }
      if(this.currency_typeOptionSelected == '') {
        this.SIModalSubmitValidation = "Select Currency Incentive Type";
      }
      if(this.SearchPsnoModal == '' || this.SearchPsnoModal == null) {
        this.SIModalSubmitValidation = "Enter CBO PSNO";
      }
      if(this.ChipPSNos.length == 0) {
        this.SIModalSubmitValidation = "Enter PSNO/s";
      }
      console.log(this.ChipPSNos);
      if(this.ModalDate == undefined) {
        this.SIModalSubmitValidation = "Select Date";
      }
      var ChipPSNosInt = this.ChipPSNos.map(rollnoName => parseInt(rollnoName.split(' - ')[0], 10));
      var CBOPSNoInt = parseInt(this.SearchPsnoModal.split(' - ')[0], 10);

      if (this.SIModalSubmitValidation.length == 0) {
        this.AddSpecialIncentive.closeModal();

        var data = {
          'SpecialIncentiveApprovalId': this.SpecialIncentiveApprovalID,
          'CBOPSNO': CBOPSNoInt,
          'ChipPSNOs': ChipPSNosInt,
          'Date': this.ModalDate,
          'SpecialIncentiveType': this.si_typeOptionSelected,
          'Currency': this.currency_typeOptionSelected,
          'TotalValue': this.Amount,
          'PeriodId': this.periodid,
          'LoggedInPSNO': this.UserPsno,
          'AppType': this.userInfo.AppType,
          'AccountName': this.accountName,
          'DealValue': this.dealValue,
          'NetNew': this.netNew,
          'SoldEBIT': this.soldEbit,
          'NewServiceLine': this.newServiceLine,
          'RevenueContribution': this.revenueContribution,
          'Revenue': this.revenue,
          'EBITPercentage': this.ebitPercentage,
          'First12MonthRevenue': this.first12MonthRevenue,
          'RateChangePercentage': this.rateChangePercentage,
          'RevenueImpact': this.revenueImpact
        }
        this.appService.SetLoadingShow(true);
        var url = this.configs.SaveSpecialIncentiveURL();
        this.appService.GetDataFromAPI(url, data)
          .then(response => {
            this.appService.SetLoadingShow(false);
            if (response.ResponseCode == this.configs.RetCodeFailure()) {
              this.dialog.open(DialogDataExampleDialog, {
                data: response.ResponseData
              });
            }
            else {
              this.dialog.open(DialogDataExampleDialog, {
                data: response.ResponseData
              });

            }
          },
            error => {

            });
      }
  }

  ToggleGrid(i) {
    var time = 1000;
    if ((i.index + 1).toString() == "1") {
      time = this.dataSource_Open_WithMe.length * 2.5;
    }
    else if ((i.index + 1).toString() == "2") {
      time = this.dataSource_Open_InProcess.length * 2.5;
    }
    else if ((i.index + 1).toString() == "3") {
      time = this.dataSource_Closed.length * 2.5;
    }
    if (time > 0) {
      var that = this;
      that.GridId = (i.index + 1).toString();
      that.appService.SetLoadingShow(true);
      window.setTimeout(function () {

        that.appService.SetLoadingShow(false); 
      },


        time);
    }
    else {
      this.GridId = (i.index + 1).toString();
    }
  }

  SelectAllForPSNO() {
    this.selectAll = !this.selectAll;
    for (var o in this.dataSource_Open_WithMe) {
      this.dataSource_Open_WithMe[o].select = this.selectAll;
    }
  }

  SelectRecords(val, period) {
    if (this.GridId == "1") {
      if (val.toString() == 'ALL') {
        this.selectAll = !this.selectAll;
        for (var o in this.dataSource_Open_WithMe) {
          this.dataSource_Open_WithMe[o].select = this.selectAll;
          if (this.dataSource_Open_WithMe[o].EnableEdit == "N") {
            this.dataSource_Open_WithMe[o].EnableEdit = "Y";
          }
          else {
            this.dataSource_Open_WithMe[o].EnableEdit = "N";
          }
        }
      }
      else {
        for (var o in this.dataSource_Open_WithMe) {
          if (val.toString() == this.dataSource_Open_WithMe[o].SpecialIncentiveApprovalId.toString()) {
            this.dataSource_Open_WithMe[o].select = !this.dataSource_Open_WithMe[o].select;
            if (this.dataSource_Open_WithMe[o].EnableEdit == "N") {
              this.dataSource_Open_WithMe[o].EnableEdit = "Y";
            }
            else {
              this.dataSource_Open_WithMe[o].EnableEdit = "N";
            }
            break;
          }
        }
      }
      this.ResetAllCheckBox();
    }
    else if (this.GridId == "2") {
      if (val.toString() == 'ALL') {
        this.selectAll = !this.selectAll;
        for (var o in this.dataSource_Open_InProcess) {
          this.dataSource_Open_InProcess[o].select = this.selectAll;
          if (this.dataSource_Open_InProcess[o].EnableEdit == "N") {
            this.dataSource_Open_InProcess[o].EnableEdit = "Y";
          }
          else {
            this.dataSource_Open_InProcess[o].EnableEdit = "N";
          }
        }
      }
      else {
        for (var o in this.dataSource_Open_InProcess) {
          if (val.toString() == this.dataSource_Open_InProcess[o].SpecialIncentiveApprovalId.toString()) {
            this.dataSource_Open_InProcess[o].select = !this.dataSource_Open_InProcess[o].select;
            if (this.dataSource_Open_InProcess[o].EnableEdit == "N") {
              this.dataSource_Open_InProcess[o].EnableEdit = "Y";
            }
            else {
              this.dataSource_Open_InProcess[o].EnableEdit = "N";
            }
            break;
          }
        }
      }
      this.ResetAllCheckBox();
    }





    else if (this.GridId == "3") {
      if (val.toString() == 'ALL') {
        this.selectAll = !this.selectAll;
        for (var o in this.dataSource_Closed) {
          this.dataSource_Closed[o].select = this.selectAll;
          if (this.dataSource_Closed[o].EnableEdit == "N") {
            this.dataSource_Closed[o].EnableEdit = "Y";
          }
          else {
            this.dataSource_Closed[o].EnableEdit = "N";
          }
        }
      }
      else {
        for (var o in this.dataSource_Closed) {
          if (val.toString() == this.dataSource_Closed[o].SpecialIncentiveApprovalId.toString()) {
            this.dataSource_Closed[o].select = !this.dataSource_Closed[o].select;
            if (this.dataSource_Closed[o].EnableEdit == "N") {
              this.dataSource_Closed[o].EnableEdit = "Y";
            }
            else {
              this.dataSource_Closed[o].EnableEdit = "N";
            }
            break;
          }
        }
      }
      this.ResetAllCheckBox();
    }
  }
  ResetAllCheckBox() {
    if (this.GridId == "1") {
      this.selectAll = true;
      for (var o in this.dataSource_Open_WithMe) {
        if (this.dataSource_Open_WithMe[o].select == false) {
          this.selectAll = false;
         break;
        }
      }
    }
    else if (this.GridId == "2") {
      this.selectAll = true;
      for (var o in this.dataSource_Open_InProcess) {
        if (this.dataSource_Open_InProcess[o].select == false) {
          this.selectAll = false;
          break;
        }
      }
    }
    else if (this.GridId == "3") {
      this.selectAll = true;
      for (var o in this.dataSource_Closed) {
        if (this.dataSource_Closed[o].select == false) {
          this.selectAll = false;
          break;
        }
      }
    }
  }

  ApproveRejectSpecialIncentives(actionType: number) {
    this.SelectedRecords = [];
    var validations = [];
    for (var o in this.dataSource_Open_WithMe) {
      if (this.dataSource_Open_WithMe[o].select == true) {
        var data = {
          //'ApprovalId': this.dataSource[o].ApprovalId,
          'SpecialIncentiveApprovalId': this.dataSource_Open_WithMe[o].SpecialIncentiveApprovalId,
          'ActionType': actionType.toString(),
          'LoggedInUserPSno': this.UserPsno,
          'Comments': this.dataSource_Open_WithMe[o].Comments,
          'PeriodId': this.periodid,
          'PSNo': this.dataSource_Open_WithMe[o].PSNo,
          'StatusId': this.dataSource_Open_WithMe[o].StatusID,
          'LoggedInUserRole': this.LoggedInUserRole,
          'name': this.dataSource_Open_WithMe[o].name,
          'RoleId': this.dataSource_Open_WithMe[o].RoleId,
          // 'AutoReleaseDate': this.dataSource_Open_WithMe[o].AutoReleaseDate,
          'UploadedBy': this.dataSource_Open_WithMe[o].UploadedBy,
          'AppType': this.userInfo.AppType,
          'RoleName': this.dataSource_Open_WithMe[o].role
        }
        if (actionType.toString() == '1') {
          // for (var x in this.dataSource_Open_WithMe[o].matricsDataList) {
          //   if ((this.dataSource_Open_WithMe[o].matricsDataList[x].H1Target_New_Save != this.dataSource_Open_WithMe[o].matricsDataList[x].H1Target_New) || (this.dataSource_Open_WithMe[o].matricsDataList[x].FYTarget_New_Save != this.dataSource_Open_WithMe[o].matricsDataList[x].FYTarget_New)) {
          //     data.UpdateTargets = 'Y';
          //     break;
          //   }
          // }
          // if (this.dataSource_Open_WithMe[o].Account_New_Save.toLowerCase().trim() != this.dataSource_Open_WithMe[o].Account_New.toLowerCase().trim()) {
          //   data.UpdateAccounts = 'Y';
          // }
        }
        this.SelectedRecords.push(data);
      }
    }
    if (this.SelectedRecords.length == 0) {
      this.dialog.open(DialogDataExampleDialog, {
        data: "Please select atleast one record to proceed"
      });
    }
    else {

      if (actionType == 2) {
        for (var o in this.SelectedRecords) {
          if (this.SelectedRecords[o].Comments == null || this.SelectedRecords[o].Comments == undefined) {
            validations.push("Please enter comments for review");
            break;
          }
          if (this.SelectedRecords[o].Comments.length == 0)
            validations.push("Please enter comments for review");
          break;
        }
      }
    }
    if (validations.length > 0) {
      this.dialog.open(DialogDataExampleDialog, {
        data: validations
      });
    }
    else {
      this.appService.SetLoadingShow(true);
      this.appService.GetDataFromAPI(this.configs.ApproveRejectSpecialIncentivesURL(), this.SelectedRecords)
        .then(response => {
          this.appService.SetLoadingShow(false);
          if (response.ResponseCode == this.configs.RetCodeFailure()) {
            this.dialog.open(DialogDataExampleDialog, {
              data: response.ResponseData
            });
          }
          else {
            this.dialog.open(DialogDataExampleDialog, {
              data: response.ResponseData
            });
            this.Reload();
            //this.ChangeView(2);
          }
        });
    }
  }

  addChipPSNo(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.ChipPSNos.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.ChipPSNoCtrl.setValue(null);
    console.log("add" +  this.ChipPSNos);
  }

  removeChipPSNo(ChipPSNo: any): void {
    const index = this.ChipPSNos.indexOf(ChipPSNo);

    if (index >= 0) {
      this.ChipPSNos.splice(index, 1);
    }
  }

  filterChipPSNo(name: string) {
    console.log("fcpn11");
    console.log(name);
    // console.log(this.allChipPSNos);
    // return this.allChipPSNos.filter(ChipPSNo =>
    //   ChipPSNo.toString().toLowerCase().indexOf(name.toString().toLowerCase()) === 0);
    return this.allChipPSNos.filter(ChipPSNo =>
         ChipPSNo.toString().toLowerCase().includes(name.toString().toLowerCase()));
  }

  selectedChipPSNo(event: MatAutocompleteSelectedEvent): void {
    this.ChipPSNos.push(event.option.viewValue);
    this.ChipPSNoInput.nativeElement.value = '';
    this.ChipPSNoCtrl.setValue(null);
  }

  DownLoadSpecialIncentives(Psno): void {
    // FYPeriodId = 16;
    // Status = 'Special Incentive Letter Released';
    // PendingWith = 'CBO';
    // AppType = 'SPM';

    var IsReleased = '';
    var SpecialIncentiveLetterType = '';
    if (this.L_SpecialIncentiveStatus === 'Special Incentive Letter Released' || this.L_SpecialIncentivePendingWith === 'CBO')
    {
      SpecialIncentiveLetterType = 'Final'; IsReleased = 'Released';
    }
    else {

      SpecialIncentiveLetterType = 'Draft'; IsReleased = 'NonReleased';
    }

    Psno = parseInt(Psno.split(' - ')[0], 10);


    this.DownLoadSpecialIncentivesApi(Psno, this.L_PeriodId, this.LoggedInUserRoleText, IsReleased, SpecialIncentiveLetterType, this.L_AppType, this.SpecialIncentiveApprovalID);
 
  }
  DownLoadSpecialIncentivesApi(Psno, FYPeriodId, Role, SpecialIncentiveStatus, SpecialIncentiveLetterType, AppType, SpecialIncentiveApprovalId): void {
    var apptypetext = 'SPM';
    if(AppType == 1) {apptypetext = 'SPM';}
    if(AppType == 1) {apptypetext = 'DIS';}

    console.log(SpecialIncentiveApprovalId);


    var data = {
      "PSNO": Psno,
      "PeriodId": FYPeriodId,
      "Role": Role,
      "SpecialIncentiveStatus": SpecialIncentiveStatus,
      "SpecialIncentiveLetterType": SpecialIncentiveLetterType,
      "AppType": apptypetext,
      "SpecialIncentiveApprovalId" : SpecialIncentiveApprovalId
    };
    this.appService.SetLoadingShow(true);
    var url = this.configs.GetSpecialIncentiveLetterURL();
    this.appService.GetDataFromAPI(url, data)
      .then(response => {
        this.appService.SetLoadingShow(false);
        if (response.ResponseCode == this.configs.RetCodeFailure()) {
          this.dialog.open(DialogDataExampleDialog, {
            data: response.ResponseData
          });
        }
        else {
          this.appService.DownloadSpecialIncentiveletter(response.ResponseData);
        }
      });


  }
  

}
